import { createRoot } from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import ErrorBoundary from './components/ErrorBoundary'
import HeadDedupe from './components/seo/HeadDedupe'
import App from './App.tsx'
import './index.css'

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <ErrorBoundary>
      <HeadDedupe />
      <App />
    </ErrorBoundary>
  </HelmetProvider>
);
